
import * as RulesActions from './actions';
import { createReducer, on, Action } from '@ngrx/store';
import { State } from './state';
import { entityAdapter } from '../adapter';
import { IRule } from '@app/models/rule.model';

const adapter = entityAdapter<IRule>();

const initialState = adapter.getInitialState({searchText: ''});

const reducer = createReducer(
  initialState,
  on(RulesActions.GetRulesAction, state => state),
  on(RulesActions.RulesLoadedAction, (state: State, { payload }) => adapter.setAll(payload, state)),
  on(RulesActions.BeginAddRuleAction, state => state),
  on(RulesActions.AddRuleFinishedAction, (state: State, { payload }) => adapter.setOne(payload, state)),
  on(RulesActions.BeginEditRuleAction, state => state),
  on(RulesActions.EditRuleSuccessAction, (state: State, { payload }) => adapter.setOne(payload, state)),
  on(RulesActions.BeginRemoveRuleAction, state => state),
  on(RulesActions.RemoveRuleAction, (state: State, { payload }) => adapter.removeOne(payload._id, state)),
  on(RulesActions.SetSearchTextAction, (state: State, { payload }) => {
    return {
      ...state,
      searchText: payload
    };
  }),

);

export function RuleReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal,
} = adapter.getSelectors();
